import { IonCard, IonCardContent, IonIcon, IonSelect, IonSelectOption } from '@ionic/react';
import { Button, Tab, Tabs, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { NavLink, useHistory, useLocation, useParams } from 'react-router-dom';
import { CompetitionDTO } from '../../models/common/CompetitionDTO';
import { EventType } from '../../models/EventType';
import { RootState } from '../../models/RootState';
import { SelectedObj } from '../../models/ExchangeSportsState';
import AllIcon from '../../assets/images/casino/icons/all.svg';
import BackarratIcon from '../../assets/images/casino/icons/backarrat.svg';
import RouletteIcon from '../../assets/images/casino/icons/roulette.svg';
import BlackJackIcon from '../../assets/images/casino/icons/blackjack.svg';
import IndianCasinoIcon from '../../assets/images/casino/icons/indian.svg';
import PokerIcon from '../../assets/images/casino/icons/poker.svg';
import SlotIcon from '../../assets/images/casino/icons/slot.svg';
import OtherIcon from '../../assets/images/casino/icons/other.svg';
import FavouriteUnfilled from '../../assets/images/casino/icons/favourite-unfilled.svg';
import {
    fetchCompetitions,
    getCompetitionsByEventType,
    setCompetition,
    fetchEventsByCompetition,
    setExchEvent,
} from '../../store';
import './CasinoMenu.scss';
import { Autocomplete } from '@material-ui/lab';
import SVLS_API from '../../svls-api';
import { PROVIDER_ID } from '../../constants/Branding';
import { DcGameNew } from '../../models/dc/DcGame';
import { Search } from '@material-ui/icons';
import { ReactComponent as SearchIcon } from "../../assets/images/common/searchIcon.svg";
import GameCardsList from '../Home/GameCardsList';

type options = [{ name: string; value: string }];

type StoreProps = {
    allowedConfig: number;
    loggedIn: boolean;
    eventTypes: EventType[];
    competitions: CompetitionDTO[];
    selectedEventType: SelectedObj;
    selectedCompetition: SelectedObj;
    setExchEvent: (event: SelectedObj) => void;
    fetchCompetitions: (eventTypeId: string) => void;
    setCompetition: (competition: SelectedObj) => void;
    fetchEventsByCompetition: (
        eventTypeId: string,
        competitionId: string
    ) => void;

    games: DcGameNew[];
    handleGameClick: Function;
    providerList: string[];
    filteredProvider: string;
    setFilteredProvider: Function;

    setCasinoGameCatTabValue: Function;
    casinoGameCatTabValue: number;

};


type InputProps = {
    eventName: string;
}

const CasinoNew: React.FC<StoreProps> = (props) => {
    const {
        allowedConfig,
        eventTypes,
        competitions,
        selectedEventType,
        selectedCompetition,
        loggedIn,
        setExchEvent,
        fetchCompetitions,
        setCompetition,
        fetchEventsByCompetition,
        games,
        handleGameClick,
        providerList,
        filteredProvider,
        setCasinoGameCatTabValue,
        casinoGameCatTabValue,
        setFilteredProvider,
    } = props;

    const history = useHistory()

    const [tabValue, setTabValue] = useState<number>(0);
    const [subTabValue, setSubTabValue] = useState<number>(0);
    const [eventName, setEventName] = useState<string>("");
    const [eventsData, setEventsData] = useState([]);

    const pathParams = useParams();
    const competition = pathParams['competition'];
    const location = useLocation();

    const handleCompetitionChange = (c: CompetitionDTO) => {
        setCompetition({ id: c.id, name: c.name, slug: c.slug });
        fetchEventsByCompetition(selectedEventType.id, c.id);
    };

    useEffect(() => {
        console.log('search-games-ctn:')
        if (!location.pathname.startsWith('/exchange_sports/inplay')) {
            if (!competitions) {
                fetchCompetitions(selectedEventType.id);
            } else {
                if (competition && selectedCompetition.slug! === competition) {
                    for (let i = 0; i < competitions.length; i += 1) {
                        if (competitions[i].slug === competition && i !== tabValue) {
                            setTabValue(i);
                            handleCompetitionChange(competitions[i]);
                            break;
                        }
                    }
                }
            }
        }
    }, [competitions, selectedCompetition]);

    useEffect(() => {
        if (!competition) {
            setCompetition({ id: '', name: '', slug: '' });
        }
    }, []);
    const getCompetitionName = (name, sportId) => {
        if (sportId === '7' || sportId === '4339') {
            let fisrtName = name?.split('_')[0];
            let lastName = name?.split('_')[1];
            return lastName + '  (' + fisrtName + ') ';
        } else {
            return name;
        }
    };

    const searchEvent = async (val) => {
        console.log(val)
        const response = await SVLS_API.get('/catalog/v2/sports-feed/sports/events:search',
            {
                headers: {
                    Authorization: sessionStorage.getItem('jwt_token'),
                },
                params: {
                    providerId: PROVIDER_ID,
                    query: val,
                },
            }
        );
        if (response.status == 200) {
            console.log('response: ', response.data)
            setEventsData(response?.data)
        }
    }
    const queryParams = new URLSearchParams(location.search);
    const ubprsovider = queryParams.get('subprovider');
    useEffect(() => {
        if (eventName) searchEvent(eventName)
    }, [eventName])

  return (
    <div className="casino-menu">
      <IonCard className="casino-menu-card web-view">
        <IonCardContent className="casino-menu-card-content">
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={casinoGameCatTabValue}
            onChange={(_, newValue) => {
              setCasinoGameCatTabValue(newValue);
              handleGameClick(
                Object(newValue).gameId,
                Object(newValue).gameName,
                Object(newValue).gameCode,
                Object(newValue).subProviderName,
                Object(newValue).providerName
              );
            }}
            aria-label="EventsTypes Menu"
            className="eventTypes-menu-tabs"
            scrollButtons="off"
          >
            <Autocomplete
              freeSolo
              id="free-solo-2-demo"
              className="search-games-ctn"
              disableClearable
              options={games}
              getOptionLabel={(option) => option.gameName}
              renderInput={(params) => (
                <>
                  <TextField
                    {...params}
                    label="Search"
                    margin="normal"
                    variant="outlined"
                    className="search-games-text autocomplete-games-text"
                    InputProps={{ ...params.InputProps, type: 'search' }}
                  />
                  <div className="search-autocomplete-icon">
                    <SearchIcon />
                  </div>
                </>
              )}
              renderOption={(props, option) => {
                return (
                  <span {...props} style={{ color: 'white' }}>
                    {props.gameName}
                  </span>
                );
              }}
            />
            <IonSelect
              className="select-filter"
              value={filteredProvider}
              placeholder="Select One"
              interface="popover"
              onIonChange={(e) => setFilteredProvider(e.detail.value)}
            >
              <IonSelectOption key={'option--1'} value={''}>
                {providerList?"All":'Loading..'}
              </IonSelectOption>
              {providerList &&
                providerList.map((opt, idx) => (
                  <IonSelectOption key={'option-' + idx} value={opt}>
                    {opt}
                  </IonSelectOption>
                ))}
            </IonSelect>

            <div
              className="sports-casino-ctn"
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <div className="eventTypes-menu-tab-divider"></div>

              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={casinoGameCatTabValue}
                onChange={(_, newValue) => {
                  setCasinoGameCatTabValue(newValue);
                }}
                aria-label="Casino Menu"
                className="casino-menu-tabs"
                scrollButtons="off"
              >
                <Tab
                  label="My Favourites"
                  value={8}
                  icon={
                    <IonIcon className="casino-icon" src={FavouriteUnfilled} />
                  }
                />
                <Tab
                  label="All"
                  value={0}
                  icon={<IonIcon className="casino-icon" src={AllIcon} />}
                />
                <Tab
                  label="Indian"
                  value={1}
                  icon={
                    <IonIcon className="casino-icon" src={IndianCasinoIcon} />
                  }
                />
                <Tab
                  label="Roulette"
                  value={2}
                  icon={<IonIcon className="casino-icon" src={RouletteIcon} />}
                />
                <Tab
                  label="Baccarat"
                  value={3}
                  icon={<IonIcon className="casino-icon" src={BackarratIcon} />}
                />
                <Tab
                  label="BlackJack"
                  value={4}
                  icon={<IonIcon className="casino-icon" src={BlackJackIcon} />}
                />
                <Tab
                  label="Poker"
                  value={5}
                  icon={<IonIcon className="casino-icon" src={PokerIcon} />}
                />
                <Tab
                  label="Slot"
                  value={6}
                  icon={<IonIcon className="casino-icon" src={SlotIcon} />}
                />
                <Tab
                  label="Other"
                  value={7}
                  icon={<IonIcon className="casino-icon" src={OtherIcon} />}
                />
              </Tabs>
              {/* ) : (
                                                    <div className="competitions-menu-msg-text">
                                                        No Competitons
                                                    </div>
                                                )
                                            ) : null
                                        ) : null} */}
            </div>
            {/* </>
                            ) : null
                        )} */}
            {/* <NavLink
              className="eventTypes-menu-nav-link"
              to="/exchange_sports/binary"
            >
              <Tab
                className="eventTypes-menu-tab"
                label="Binary"
                value={11010011}
              />
            </NavLink> */}
          </Tabs>
        </IonCardContent>
      </IonCard>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
    return {
        eventTypes: state.exchangeSports.eventTypes,
        competitions: getCompetitionsByEventType(
            state.exchangeSports.competitions,
            state.exchangeSports.selectedEventType.id
        ),
        selectedEventType: state.exchangeSports.selectedEventType,
        selectedCompetition: state.exchangeSports.selectedCompetition,
        allowedConfig: state.common.allowedConfig,
        loggedIn: state.auth.loggedIn,
    };
};

const mapDispatchToProps = (dispatch: Function) => {
    return {
        fetchCompetitions: (eventTypeId: string) =>
            dispatch(fetchCompetitions(eventTypeId)),
        setExchEvent: (event: SelectedObj) => dispatch(setExchEvent(event)),
        setCompetition: (competition: SelectedObj) =>
            dispatch(setCompetition(competition)),
        fetchEventsByCompetition: (eventTypeId: string, competitionId: string) =>
            dispatch(fetchEventsByCompetition(eventTypeId, competitionId, [])),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CasinoNew);
